import { IitemAspiranteResponse } from 'src/redux/api/types/aspirantes';
import * as Yup from 'yup';


// Filtros form
export interface IAsignarGestorForm {
    usuarioAsignadoId: string
}

export const setValoresInicialesNuevoMaestro = (valores?: IitemAspiranteResponse) => {
        return {usuarioAsignadoId: valores?.usuarioAsignadoId || ''}
};


export const esquemaDeValidacion = Yup.object({
    usuarioAsignadoId:  Yup.string().required("Debe seleccionar un usuario"),
});


